import React, { useContext, useState } from "react";

import ConfigContext from "../../context/config-context";
import appStyles from "../../app.module.css";
import styles from "../quote/components/quote-form/quote-form.module.css";
import GoogleMap from "./components/GoogleMap";
import SettlementsDetails from "./components/Settlements-Details";
import SettlementsEmpDetails from "./config/recent-settlement-config.json";
import rsStyles from "./recent-settlement.module.css";

const RecentSettlements = () => {
  const { employee } = useContext(ConfigContext);

  const [settlementDetails, setSettlementDetails] = useState(
    SettlementsEmpDetails[employee]["3 Months"]
  );

  const handleChange = (settlementValue) => {
    setSettlementDetails(SettlementsEmpDetails[employee][settlementValue]);
  };

  return (
    <>
      {settlementDetails ? (
        <>
          <h2 className={`${appStyles.colorPrimary} ${appStyles.textCenter}`}>
            My recent settlements
          </h2>
          <div className={styles.recentSettlementTabs}>
            <div className={styles.formFieldRadio}>
              <div className={styles.quoteFormBlockContent}>
                <div className={styles.formFieldRadioElement}>
                  {Object.keys(SettlementsEmpDetails[employee]).map(
                    (item, index) => (
                      <label key={item} htmlFor={item}>
                        <input
                          type="radio"
                          value={item}
                          id={item}
                          name="recent-settlements"
                          defaultChecked={index === 0}
                          onChange={(e) => {
                            handleChange(e.target.value);
                          }}
                        />
                        <span className={styles.formFieldRadioMark}>
                          {item}
                        </span>
                      </label>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={rsStyles.recentSettlementWrapper}>
            <div className={rsStyles.recentSettlementMap}>
              <GoogleMap
                settlementDetails={settlementDetails.pinCodeWiseData}
              />
            </div>
            <div className={rsStyles.recentSettlementDetails}>
              <SettlementsDetails
                settlementDetails={settlementDetails.result}
              />
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default RecentSettlements;
